import React from 'react';
import { View } from 'react-native';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';

import { BaseText } from '@components';

const Container = styled(View)({
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
});

export const MyMusicScreen = observer(() => {
  return (
    <Container>
      <BaseText>My Music Screen</BaseText>
    </Container>
  );
});
